import axios from 'axios';
import {getApiConfig} from '../config/configProvider';

const getBaseUrl = () => {
  const config = getApiConfig();
  return (config && config.signupUrl) || '/api/account-signup/api/v1/signup';
};

// The global axios response interceptor resolves a cancelled request (e.g.
// one cancelled by the app's idle-mode handling) to `null` instead of
// rejecting — reading `.data` off that would throw a raw TypeError, so this
// surfaces a clear, catchable error for the existing call-site try/catch
// blocks instead.
const extractData = res => {
  if (!res) {
    const err = new Error('Request was interrupted. Please try again.');
    err.requestInterrupted = true;
    throw err;
  }
  return res.data;
};

export default class CreateSignupApi {
  static initSignup(lat, lng, referringEmployeeId, employeeName, headers) {
    return axios
      .post(
        `${getBaseUrl()}`,
        {
          lat,
          lng,
          source: 'EMPLOYEE_REFERRAL',
          ...(referringEmployeeId ? {referringEmployeeId} : {}),
          ...(employeeName ? {employeeName} : {}),
        },
        {headers}
      )
      .then(extractData);
  }

  // fulfillmentType (DELIVERY/COLLECTION) is recorded on the signup before its
  // documents are sent to invoice-scanning, so the price comparison uses it.
  static uploadDocuments(id, files, location, fulfillmentType, headers) {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    const params = {};
    if (location) {
      params.lat = location.lat;
      params.lng = location.lng;
    }
    if (fulfillmentType) {
      params.fulfillmentType = fulfillmentType;
    }
    return axios
      .post(`${getBaseUrl()}/${id}/document`, formData, {
        headers: {...headers, 'Content-Type': 'multipart/form-data'},
        params,
      })
      .then(extractData);
  }

  static deleteDocument(id, documentId, headers) {
    return axios
      .delete(`${getBaseUrl()}/${id}/document/${documentId}`, {headers})
      .then(extractData);
  }

  static getSignup(id, headers) {
    return axios.get(`${getBaseUrl()}/${id}`, {headers}).then(extractData);
  }

  static updateField(id, fieldName, value, headers) {
    return axios
      .put(`${getBaseUrl()}/${id}/resolved/${fieldName}`, {value}, {headers})
      .then(extractData);
  }

  static submitSignup(id, headers) {
    return axios
      .post(`${getBaseUrl()}/${id}/submit`, null, {headers})
      .then(extractData);
  }
}
